import { useMemo } from "react";
import { Spinner } from "../../components/loaders";
import AdviceRegister from "../../features/adviceregister";
import { AdviceRegisterDefaultFilters, FilterProvider } from "../../hooks/FilterContext";
import { useFetchDefaultServiceLevelAgreementsQuery } from "../../services/clientserviceterms";

const ManagementReportsAdviceRegisterPage = () => {
    const { data: slas, isFetching: isFetchingSlas } = useFetchDefaultServiceLevelAgreementsQuery();

    const defaultFilters = useMemo(() => {
        if (!slas)
            return AdviceRegisterDefaultFilters;

        return {
            ...AdviceRegisterDefaultFilters,
            serviceLevelAgreementIds: slas.map(x => x.agreementId)
        }
    }, [slas]);

    if (isFetchingSlas)
        return <Spinner className="m-auto" animation="border" />;

    return <FilterProvider defaultFilters={defaultFilters} filterStore={"management.reports.advice-register"}>
        <AdviceRegister />
    </FilterProvider>
}

export default ManagementReportsAdviceRegisterPage;
